export default __webpack_public_path__ + "static/media/blog-img250.980e3629.jpg";